// The Oireachtas side of the Competitors page (card beb095f8, Devin
// 2026-10-22: extend the existing page). GET /oireachtas/:id/competitor-lists
// is mapped onto the shapes the feis page already draws (countsModel): level
// tabs are the syllabus groups ("Solo Championships", "2-Hand Teams" ...),
// rows are competitions, "Your competitions" / "Your school's dancers" come
// from the server's mine / school. A competition opens once its draw is
// locked; its running order is names only until the 7:00 am numbers release
// on its day, then numbers and each round's order (the server decides which).
import { compareComps } from "../../Teacher/Oireachtas/compSort";

const item = (c) => ({
  id: String(c._id),
  code: c.code,
  name: c.name,
  age: "",
  count: c.count || 0,
  subs: [],
  // opens once the draw is locked (counts before that)
  open: !!c.drawn && (c.count || 0) > 0,
});

// [{ key, title, items }] in syllabus order (compSort, as every Oireachtas list)
export const oireachtasSections = (competitions) => {
  const sections = [];
  const byKey = new Map();
  for (const c of (competitions || []).slice().sort(compareComps)) {
    const key = c.group || "Competitions";
    if (!byKey.has(key)) {
      const sec = { key, title: key, items: [] };
      byKey.set(key, sec);
      sections.push(sec);
    }
    byKey.get(key).items.push(item(c));
  }
  return sections;
};

// The family's own competitions: [{ ...item, level, yours: [first names] }]
export const oireachtasYours = (sections, mine) => {
  const who = new Map((mine || []).map((m) => [String(m.competition_id), m.names || []]));
  const out = [];
  for (const sec of sections) {
    for (const i of sec.items) if (who.has(i.id)) out.push({ ...i, level: sec.title, yours: who.get(i.id) });
  }
  return out;
};

// A teacher's school's dancers: [{ id, name, comps: [{ ...item, level }] }]
export const oireachtasSchoolDancers = (sections, school) => {
  const byId = new Map();
  for (const sec of sections) for (const i of sec.items) byId.set(i.id, { ...i, level: sec.title });
  return (school || []).map((d, n) => ({
    id: `${d.name}-${n}`,
    name: d.name,
    comps: (d.competitions || []).map((id) => byId.get(String(id))).filter(Boolean),
  }));
};

// The tabs over an opened competition's list: none before the release (one
// plain list of names), "Round 1" ... after it.
export const roundTabs = (detail) =>
  detail?.released ? (detail.rounds || []).map((r) => ({ key: String(r.round), title: `Round ${r.round}` })) : [];

// The rows to show: [{ id, number, name, school, yours }]
export const listRows = (detail, round) => {
  if (!detail?.drawn) return [];
  const rows = detail.released
    ? ((detail.rounds || []).find((r) => String(r.round) === String(round)) || (detail.rounds || [])[0] || { order: [] }).order
    : detail.names || [];
  return rows.map((p, i) => ({ id: `${p.number || ""}-${i}`, number: p.number || "", name: p.name, school: p.school, yours: !!p.yours }));
};

// The line under the competition's name.
export const releaseLine = (detail, round) => {
  if (!detail) return "";
  if (!detail.drawn) return "The running order shows here once it's out.";
  if (!detail.released) {
    return detail.releaseText
      ? `Names in running order. Competitor numbers and each round's order come out at ${detail.releaseText}.`
      : "Names in running order. Competitor numbers come out on the morning of this competition's day.";
  }
  const r = (detail.rounds || []).find((x) => String(x.round) === String(round));
  if (r?.pending) return `Round ${round}'s order shows here once the recall is published.`;
  if (Number(round) >= 3) return `Round ${round} as danced: the recalled dancers.`;
  return `Round ${round || 1} as danced.`;
};
